import React from 'react';
import BaseOutlierCountAlert from "./BaseOutlierCountAlert";

const DollarsCountOutlier = () => {
    return <BaseOutlierCountAlert accessor={'dollar'} alertType={'Dollar'} threshold={25}/>;
};

export default DollarsCountOutlier;